// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import Welcome from './pages/Welcome';
import Message from './pages/Message';

const theme = createTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/message" element={<Message />} />
          <Route path="/:name" element={<Message />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
